import { render, staticRenderFns } from "./Decode.vue?vue&type=template&id=2a124a3b&"
import script from "./Decode.vue?vue&type=script&lang=js&"
export * from "./Decode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports